import { useSelector } from 'react-redux';
import { Flow } from 'signup-constants/Flow';
import { getFlowConfig } from '../flow-initial/getFlowConfig';
import { getActiveError } from '../store/error/selectors';
import { getPostAccountCreationSteps } from '../store/flow/selectors';
import { getActiveLoading } from '../store/loading-status/selectors';
import { isFlow } from '../utils/isFlow';
import { getStepConfig } from '../views/getStepConfig';
import { useCurrentStep } from './useCurrentStep';
import { useSignupEmbedder } from 'signup-embedder/hooks/useSignupEmbedder';
import { useMessage } from '../messaging/useMessage';
import { LayoutType } from 'signup-components/types';
export const useLayoutTemplate = () => {
  const postAccountCreationSteps = useSelector(getPostAccountCreationSteps);
  const {
    currentStep
  } = useCurrentStep();
  const activeError = useSelector(getActiveError);
  const step = activeError || currentStep;
  const stepConfig = getStepConfig(step);
  const activeLoading = useSelector(getActiveLoading);
  const {
    isActive: isInstanceOfSignupEmbedder
  } = useSignupEmbedder();
  const showMessagingAboveContent = stepConfig && stepConfig.showMessagingAboveContent;
  const {
    shouldDisplayMessaging
  } = useMessage();
  const layoutType = shouldDisplayMessaging && !showMessagingAboveContent ? LayoutType.TwoColumn : getFlowConfig().getLayoutType();
  const shouldStepUseLayoutTemplate = stepConfig ? stepConfig.shouldStepUseLayoutTemplate : false;
  const isDirectoryListing = isFlow(Flow.DirectoryListing);
  const isPostAccountCreationStep = postAccountCreationSteps.includes(currentStep);

  if (activeError || activeLoading) {
    return {
      shouldUseLayoutTemplate: false,
      layoutType
    };
  }

  if (isPostAccountCreationStep && !isDirectoryListing && !isInstanceOfSignupEmbedder) {
    return {
      shouldUseLayoutTemplate: false,
      layoutType
    };
  }

  if (shouldStepUseLayoutTemplate) {
    return {
      shouldUseLayoutTemplate: true,
      layoutType
    };
  }

  return {
    shouldUseLayoutTemplate: false,
    layoutType
  };
};